module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "top-content"
    }
  }, [_c('h1', [_vm._v("Top Content")]), _vm._v(" "), _c('div', {
    staticClass: "items"
  }, _vm._l((_vm.topContent), function(media) {
    return _c('div', {
      staticClass: "item"
    }, [(media.posterStringUrl && media.mediaType === 'Image') ? _c('router-link', {
      attrs: {
        "to": ("/Developer/" + (media.posterStringUrl) + "/Portfolio/" + (media.albumStringUrl) + "/" + (media.pieceStringUrl))
      }
    }, [_c('div', {
      staticClass: "thumb",
      style: (("background-image: url('https://www.develteam.com/userdata/mediaThumbs/" + (media.mediaUrl) + "')"))
    })]) : _vm._e(), _vm._v(" "), (media.subPosterStringUrl && media.mediaType === 'Image') ? _c('router-link', {
      attrs: {
        "to": ("/Game/" + (media.subPosterStringUrl) + "/Media/" + (media.albumStringUrl) + "/" + (media.pieceStringUrl))
      }
    }, [_c('div', {
      staticClass: "thumb",
      style: (("background-image: url('https://www.develteam.com/userdata/mediaThumbs/" + (media.mediaUrl) + "')"))
    })]) : _vm._e(), _vm._v(" "), (media.posterStringUrl && media.mediaType !== 'Image' && media.previewUrl) ? _c('router-link', {
      attrs: {
        "to": ("/Developer/" + (media.posterStringUrl) + "/Portfolio/" + (media.albumStringUrl) + "/" + (media.pieceStringUrl))
      }
    }, [_c('div', {
      staticClass: "thumb",
      style: (("background-image: url('https://www.develteam.com/userdata/mediaThumbs/" + (media.previewUrl) + "')"))
    })]) : _vm._e(), _vm._v(" "), (media.subPosterStringUrl && media.mediaType !== 'Image' && media.previewUrl) ? _c('router-link', {
      attrs: {
        "to": ("/Game/" + (media.subPosterStringUrl) + "/Media/" + (media.albumStringUrl) + "/" + (media.pieceStringUrl))
      }
    }, [_c('div', {
      staticClass: "thumb",
      style: (("background-image: url('https://www.develteam.com/userdata/mediaThumbs/" + (media.previewUrl) + "')"))
    })]) : _vm._e(), _vm._v(" "), (media.posterStringUrl && media.mediaType !== 'Image' && !media.previewUrl) ? _c('router-link', {
      attrs: {
        "to": ("/Developer/" + (media.posterStringUrl) + "/Portfolio/" + (media.albumStringUrl) + "/" + (media.pieceStringUrl))
      }
    }, [(media.mediaType === 'Audio') ? _c('div', {
      staticClass: "thumb icon-thumb"
    }, [_c('div', {
      staticClass: "icon-container"
    }, [_c('i', {
      staticClass: "fas fa-volume-up"
    })])]) : _vm._e(), _vm._v(" "), (media.mediaType === 'External') ? _c('div', {
      staticClass: "thumb icon-thumb"
    }, [_c('div', {
      staticClass: "icon-container"
    }, [_c('i', {
      staticClass: "fas fa-link"
    })])]) : _vm._e(), _vm._v(" "), (media.mediaType === 'Flash') ? _c('div', {
      staticClass: "thumb icon-thumb"
    }, [_c('div', {
      staticClass: "icon-container"
    }, [_c('i', {
      staticClass: "fas fa-rocket"
    })])]) : _vm._e(), _vm._v(" "), (media.mediaType === 'Archive') ? _c('div', {
      staticClass: "thumb icon-thumb"
    }, [_c('div', {
      staticClass: "icon-container"
    }, [_c('i', {
      staticClass: "fas fa-download"
    })])]) : _vm._e(), _vm._v(" "), (media.mediaType === 'Text') ? _c('div', {
      staticClass: "thumb icon-thumb"
    }, [_c('div', {
      staticClass: "icon-container"
    }, [_c('i', {
      staticClass: "fas fa-download"
    })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (media.subPosterStringUrl && media.mediaType !== 'Image' && media.previewUrl) ? _c('router-link', {
      attrs: {
        "to": ("/Game/" + (media.subPosterStringUrl) + "/Media/" + (media.albumStringUrl) + "/" + (media.pieceStringUrl))
      }
    }, [(media.mediaType === 'Audio') ? _c('div', {
      staticClass: "thumb icon-thumb"
    }, [_c('div', {
      staticClass: "icon-container"
    }, [_c('i', {
      staticClass: "fas fa-volume-up"
    })])]) : _vm._e(), _vm._v(" "), (media.mediaType === 'External') ? _c('div', {
      staticClass: "thumb icon-thumb"
    }, [_c('div', {
      staticClass: "icon-container"
    }, [_c('i', {
      staticClass: "fas fa-link"
    })])]) : _vm._e(), _vm._v(" "), (media.mediaType === 'Flash') ? _c('div', {
      staticClass: "thumb icon-thumb"
    }, [_c('div', {
      staticClass: "icon-container"
    }, [_c('i', {
      staticClass: "fas fa-rocket"
    })])]) : _vm._e(), _vm._v(" "), (media.mediaType === 'Archive') ? _c('div', {
      staticClass: "thumb icon-thumb"
    }, [_c('div', {
      staticClass: "icon-container"
    }, [_c('i', {
      staticClass: "fas fa-download"
    })])]) : _vm._e(), _vm._v(" "), (media.mediaType === 'Text') ? _c('div', {
      staticClass: "thumb icon-thumb"
    }, [_c('div', {
      staticClass: "icon-container"
    }, [_c('i', {
      staticClass: "fas fa-download"
    })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (media.mediaType === 'Audio') ? _c('div', {
      staticClass: "audio-container thumb"
    }, [_c('audio', {
      attrs: {
        "controls": ""
      }
    }, [_c('source', {
      attrs: {
        "src": ("https://www.develteam.com/userdata/media/" + (media.mediaUrl)),
        "type": "audio/mpeg"
      }
    }), _vm._v("\n                Your browser does not support the audio tag.\n            ")])]) : _vm._e(), _vm._v(" "), (media.mediaType === 'Youtube') ? _c('fake-youtube', {
      attrs: {
        "src": media.mediaUrl
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "details"
    }, [(media.posterStringUrl) ? _c('h2', [_c('router-link', {
      attrs: {
        "to": ("/Developer/" + (media.posterStringUrl) + "/Portfolio/" + (media.albumStringUrl) + "/" + (media.pieceStringUrl))
      }
    }, [_vm._v("\n                        " + _vm._s(media.title) + "\n                    ")])], 1) : _vm._e(), _vm._v(" "), (media.subPosterStringUrl) ? _c('h2', [_c('router-link', {
      attrs: {
        "to": ("/Game/" + (media.subPosterStringUrl) + "/Media/" + (media.albumStringUrl) + "/" + (media.pieceStringUrl))
      }
    }, [_vm._v("\n                        " + _vm._s(media.title) + "\n                    ")])], 1) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "poster"
    }, [(media.subPosterStringUrl) ? [_c('i', {
      staticClass: "fas fa-gamepad"
    }), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": ("/Game/" + (media.subPosterStringUrl))
      }
    }, [_vm._v("\n                            " + _vm._s(media.subPosterAlias) + "\n                        ")])] : _vm._e(), _vm._v(" "), (media.posterStringUrl) ? [_c('i', {
      staticClass: "fas fa-user"
    }), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": ("/Developer/" + (media.posterStringUrl))
      }
    }, [_vm._v("\n                            " + _vm._s(media.posterAlias) + "\n                        ")])] : _vm._e()], 2), _vm._v(" "), (media.subPosterStringUrl) ? _c('div', {
      staticClass: "media-stats"
    }, [_c('router-link', {
      attrs: {
        "to": ("/Game/" + (media.subPosterStringUrl) + "/Media/" + (media.albumStringUrl) + "/" + (media.pieceStringUrl))
      }
    }, [_c('i', {
      staticClass: "far fa-heart"
    }), _vm._v(" " + _vm._s(media.voteTotal) + "\n                    ")]), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": ("/Game/" + (media.subPosterStringUrl) + "/Media/" + (media.albumStringUrl) + "/" + (media.pieceStringUrl))
      }
    }, [_c('i', {
      staticClass: "far fa-comment-alt"
    }), _vm._v(" " + _vm._s(media.commentCount) + "\n                    ")])], 1) : _vm._e(), _vm._v(" "), (media.posterStringUrl) ? _c('div', {
      staticClass: "media-stats"
    }, [_c('router-link', {
      attrs: {
        "to": ("/Developer/" + (media.posterStringUrl) + "/Portfolio/" + (media.albumStringUrl) + "/" + (media.pieceStringUrl))
      }
    }, [_c('i', {
      staticClass: "far fa-heart"
    }), _vm._v(" " + _vm._s(media.voteTotal) + "\n                    ")]), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": ("/Developer/" + (media.posterStringUrl) + "/Portfolio/" + (media.albumStringUrl) + "/" + (media.pieceStringUrl))
      }
    }, [_c('i', {
      staticClass: "far fa-comment-alt"
    }), _vm._v(" " + _vm._s(media.commentCount) + "\n                    ")])], 1) : _vm._e()])], 1)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-43f4f52a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/HomeDashboard/TopContent.vue
// module id = 862
// module chunks = 2